import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import snackbar, { SnackbarState }  from './modules/snackbar'
import cart, { CartState } from './modules/cart'
import loginUser, { LoginUserState } from './modules/loginUser'
import url, { UrlState } from './modules/url'


const APP_NAME = 'okasoecb2b'

interface RootState {
  loginUser: LoginUserState;
  snackbar: SnackbarState;
  cart: CartState;
}

export default createStore<RootState>({
  modules: {
    snackbar,
    cart,
    url,
    loginUser,
  },
  plugins: [createPersistedState(
    {
      key: APP_NAME,
      paths: [
        'loginUser.customer',
        'loginUser.staff',
        'url.itemSearchQuery',
      ],
      storage: window.localStorage
    }
  )]
})
